var _style, _g, _g2, _polygon, _polygon2, _path, _path2, _polygon3, _polygon4, _path3, _path4, _g3, _g4, _path5, _path6, _path7, _g5, _g6, _g7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrigoUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.6 198",
    style: {
      enableBackground: "new 0 0 230.6 198"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#002B50;}\n\t.st1{fill:#334D6F;}\n\t.st2{fill:#AFB8BF;}\n\t.st3{fill:#848E96;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:#ECEEF0;}\n\t.st6{fill:url(#SVGID_2_);}\n\t.st7{fill:#798793;}\n\t.st8{fill:url(#SVGID_3_);}\n\t.st9{fill:url(#SVGID_4_);}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:#F5F5F5;}\n\t.st12{fill:#2C506E;}\n\t.st13{fill:#627C93;}\n\t.st14{fill:#96C2E7;}\n\t.st15{fill:url(#SVGID_5_);}\n\t.st16{fill:url(#SVGID_6_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REPERES"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "99.03,181.14 99.03,183.95 96.11,182.26 94.89,181.56 66.9,165.42 66.91,162.61 94.89,178.74  96.11,179.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "163.63,146.53 99.03,183.95 99.03,179.65 163.63,142.24  "
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "65.79,162.61 96.04,180.03 95.97,69.75 65.79,52.33  "
  })), /*#__PURE__*/React.createElement("g", null, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "162.26,141.76 128.83,161.1 128.76,50.82 162.19,31.48  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2066.4949,
    y1: 97.0517,
    x2: -2031.7645,
    y2: 97.0517,
    gradientTransform: "matrix(-1 0 0 1 -1901.6868 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1B9C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9099,
    style: {
      stopColor: "#DCE0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    style: {
      stopColor: "#AFB8BF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.87,31.86l1.61,0.92c0.21,0.12,0.32,0.27,0.33,0.43l0,110.38c0,0.17-0.11,0.34-0.34,0.47l-31.16,17.99 c-0.45,0.26-1.18,0.26-1.63,0l-1.61-0.92V50.79L162.87,31.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M164.47,33.72l-31.16,17.99c-0.45,0.26-1.18,0.26-1.63,0l-1.61-0.92l32.79-18.93l1.61,0.92 C164.92,33.04,164.92,33.46,164.47,33.72z"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "128.83,161.1 96.04,180.03 95.97,69.75 128.76,50.82  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "132.01,14.05 162.19,31.48 95.97,69.75 65.79,52.33  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -2033.0615,
    y1: 116.3991,
    x2: -1998.3313,
    y2: 116.3991,
    gradientTransform: "matrix(-1 0 0 1 -1901.6868 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1B9C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9099,
    style: {
      stopColor: "#DCE0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    style: {
      stopColor: "#AFB8BF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M129.43,51.21l1.61,0.92c0.21,0.12,0.32,0.27,0.33,0.43l0,110.38c0,0.17-0.11,0.34-0.34,0.47L99.88,181.4 c-0.45,0.26-1.18,0.26-1.63,0l-1.61-0.92V70.14L129.43,51.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.04,53.06L99.88,71.06c-0.45,0.26-1.18,0.26-1.63,0l-1.61-0.92l32.79-18.93l1.61,0.92 C131.49,52.38,131.49,52.81,131.04,53.06z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "139.83,69.68 134.78,66.76 136.94,65.5 142,68.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "139.83,72.18 134.78,69.26 134.78,66.75 139.83,69.67  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "139.83,125.49 134.78,122.57 136.94,121.32 142,124.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "139.83,127.99 134.78,125.07 134.78,122.57 139.83,125.49  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.4909,
    y1: 98.7739,
    x2: 142.7333,
    y2: 98.7739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1B9C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9099,
    style: {
      stopColor: "#DCE0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    style: {
      stopColor: "#AFB8BF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M142.73,68.95v58.93c-0.07,0.16-0.22,0.31-0.43,0.44c-0.33,0.19-0.76,0.28-1.19,0.28 c-0.43,0-0.86-0.1-1.19-0.28c-0.22-0.13-0.36-0.28-0.43-0.44V68.95H142.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.4909,
    y1: 98.7739,
    x2: 141.1121,
    y2: 98.7739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#546676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    style: {
      stopColor: "#AFB8BF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M141.11,68.95v59.65c-0.43,0-0.86-0.1-1.19-0.28c-0.22-0.13-0.36-0.28-0.43-0.44V68.95H141.11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142.26,68.29c0.63,0.37,0.63,0.96,0,1.32c-0.63,0.37-1.66,0.37-2.29,0c-0.63-0.37-0.63-0.96,0-1.32 C140.6,67.92,141.62,67.92,142.26,68.29z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "124.42,118.71 110.56,126.71 110.56,98.37 124.42,90.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "123.46,98.84 123.46,118.15 111.53,125.04 111.53,105.72 119.46,101.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "123.46,92.3 123.46,97.17 111.53,104.06 111.53,99.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "123.46,117.94 123.46,118.15 111.53,125.04 111.53,120.22 119.46,115.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "119.46,101.14 123.46,98.84 123.46,118.04 119.46,115.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "121.46,94.27 121.46,97.51 113.52,102.09 113.52,98.85  "
  })))), /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "133.19,73.38 128.13,70.46 130.3,69.2 135.36,72.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "133.19,75.88 128.13,72.96 128.13,70.45 133.19,73.37  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "133.19,129.19 128.13,126.27 130.3,125.02 135.36,127.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "133.19,131.69 128.13,128.77 128.13,126.27 133.19,129.19  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.8469,
    y1: 102.4738,
    x2: 136.0893,
    y2: 102.4738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B1B9C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9099,
    style: {
      stopColor: "#DCE0E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    style: {
      stopColor: "#AFB8BF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M136.09,72.65v58.93c-0.07,0.16-0.22,0.31-0.43,0.44c-0.33,0.19-0.76,0.28-1.19,0.28 c-0.43,0-0.86-0.1-1.19-0.28c-0.22-0.13-0.36-0.28-0.43-0.44V72.65H136.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.8469,
    y1: 102.4738,
    x2: 134.4682,
    y2: 102.4738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#546676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    style: {
      stopColor: "#AFB8BF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M134.47,72.65v59.65c-0.43,0-0.86-0.1-1.19-0.28c-0.22-0.13-0.36-0.28-0.43-0.44V72.65H134.47z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M135.61,71.99c0.63,0.37,0.63,0.96,0,1.32c-0.63,0.37-1.66,0.37-2.29,0c-0.63-0.37-0.63-0.96,0-1.32 C133.96,71.62,134.98,71.62,135.61,71.99z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrigoUs);
export default __webpack_public_path__ + "static/media/frigo-us.6a7a9c4baa3820203c2379444e9b9ccf.svg";
export { ForwardRef as ReactComponent };